import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

const StudentFileProposalsAcceptedCell = props => (
  <div>
    <b>
      {props.tReady ? (
        props.isAccepted ? (
          props.t("SingleExamination.StudentFileProposalsTab.IsAccepted")
        ) : (
          props.t("SingleExamination.StudentFileProposalsTab.IsNotAccepted")
        )
      ) : (
        <FontAwesomeIcon icon={faCircleNotch} />
      )}
    </b>
  </div>
);

export default withTranslation()(StudentFileProposalsAcceptedCell);
